import React, { useContext, useEffect, useState } from "react";
import styles from './PermissionModal.module.css';
import ModalShell from "components/shared/modal/ModalShell";
import useTheme from "config/useTheme";
import ModalContext from "config/context/modalContext";
import { useGenerateKeypair } from "api/authentication/usePrivateKey";
import { useEditPermission } from "api/permissions/usePermissions";
import SuccessfullActionModal from "./SuccessfullActionModal";
import Loader from "components/shared/loader/Loader";
import PrivateKeyField from "components/shared/private-key-field/PrivateKeyField";

const ChangeKeypairModal = ({
  permissionName,
  permissionParentName,
  finalStepDuration,
}) => {
  const { dark } = useTheme();
  const { handleModal } = useContext(ModalContext);
  const [isValid, setIsValid] = useState(false);
  const [data, setData] = useState({
    permission_name: permissionName,
    permission_parent_name: permissionParentName,
    permission_parent_private_key: "",
    permission_public_key: "",
  });

  const {
    response: keypairResponse,
    getKeypair,
  } = useGenerateKeypair();

  const { response, loading, error, changeKeypair, resetServerStatus } =
    useEditPermission({
      permissionName: data?.permission_name,
      permissionParentName: data?.permission_parent_name,
      permissionParentPrivateKey: data?.permission_parent_private_key,
      permissionPublicKey: data?.permission_public_key,
    });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      !data.permission_name ||
      !data.permission_parent_private_key ||
      !data.permission_public_key
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [data]);

  useEffect(() => {
    if (keypairResponse?.publicKey) {
      setData((prevData) => ({
        ...prevData,
        permission_public_key: keypairResponse?.publicKey,
      }));
    }
  }, [keypairResponse]);

  useEffect(() => {
    if (response?.status && !error) {
      setTimeout(() => {
        resetServerStatus();
        handleModal(false);
        window.location.reload();
      }, finalStepDuration || 1600);
    }
    // `handleModal` i `resetServerStatus` su sada postojani (`useCallback`), pa
    // smeju u zavisnosti: effect se okida na ishod, a ne pri svakom
    // iscrtavanju. Bez toga bi svako iscrtavanje zakazivalo nov `setTimeout`
    // za zatvaranje prozora.
  }, [response, error, handleModal, resetServerStatus, finalStepDuration]);

  const handleChangeKeypair = (event) => {
    event.preventDefault();
    changeKeypair();
  };

  if (loading) {
    return (
      <ModalShell>
        <Loader />
      </ModalShell>
    );
  }

  if (response?.status) {
    return (
      <ModalShell>
        <SuccessfullActionModal message={response?.message} />
      </ModalShell>
    );
  }

  return (
    <ModalShell closeOnOverlay={true}>
      <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
        <div className={styles.label}>Change keypair</div>
        <form id="change_keypair_form" onSubmit={handleChangeKeypair}>
          <div className={styles.input_group}>
            <p>Set new public key</p>
            <div
              className={`${styles.input_block} ${styles.input_block__with_btn}`}
            >
              <input
                type="text"
                placeholder="Public key"
                name="permission_public_key"
                value={data.permission_public_key}
                onChange={handleInputChange}
              />
              <button type="button" onClick={() => getKeypair()}>
                Generate new keypair
              </button>
            </div>
          </div>

          {keypairResponse?.privateKey && (
            <div className={styles.input_group}>
              <p>New private key</p>
              <div className={styles.key_shell}>
                <PrivateKeyField
                  value={keypairResponse?.privateKey}
                  label
                />
              </div>
            </div>
          )}

          <div className={styles.input_group}>
            <p>"{permissionParentName}" permission private key</p>
            <div className={styles.input_block}>
              <PrivateKeyField
                name="permission_parent_private_key"
                value={data.permission_parent_private_key}
                onChange={handleInputChange}
                placeholder="Private key"
              />
            </div>
          </div>
        </form>
        {error && (
          <div className={styles.form_msg}>
            <span>{error}</span>
          </div>
        )}
        <div className={styles.form_actions}>
          <button type="submit" form="change_keypair_form" disabled={!isValid}>
            Change
          </button>
          <button onClick={() => handleModal(false)}>Cancel</button>
        </div>
      </div>
    </ModalShell>
  );
};

export default ChangeKeypairModal;
